var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cashier-choose" }, [
    _c("div", { staticClass: "top-bar" }, [
      _c("span", { staticClass: "top-title" }, [_vm._v("选择工作台")]),
      _c(
        "div",
        { staticClass: "top-right" },
        [
          _vm.storeName
            ? _c("span", { staticClass: "top-store" }, [
                _vm._v(_vm._s(_vm.storeName)),
              ])
            : _vm._e(),
          _c("span", { staticClass: "top-user" }, [
            _vm._v(_vm._s(_vm.userName)),
          ]),
          _c(
            "a-button",
            { attrs: { size: "small" }, on: { click: _vm.handleLogout } },
            [_vm._v("退出登录")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "choose-body" }, [
      _vm.hasRetail
        ? _c(
            "div",
            {
              staticClass: "choose-card retail",
              on: {
                click: function ($event) {
                  return _vm.go("/cashier/retail")
                },
              },
            },
            [
              _c("a-icon", {
                staticClass: "card-icon",
                attrs: { type: "shopping-cart" },
              }),
              _c("div", { staticClass: "card-name" }, [_vm._v("零售收银")]),
              _c("div", { staticClass: "card-desc" }, [
                _vm._v("商品零售 · 会员结算"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.hasDining
        ? _c(
            "div",
            {
              staticClass: "choose-card dining",
              on: {
                click: function ($event) {
                  return _vm.go("/cashier/dining")
                },
              },
            },
            [
              _c("a-icon", {
                staticClass: "card-icon",
                attrs: { type: "coffee" },
              }),
              _c("div", { staticClass: "card-name" }, [_vm._v("餐饮收银")]),
              _c("div", { staticClass: "card-desc" }, [
                _vm._v("桌台开台 · 点餐结算"),
              ]),
            ],
            1
          )
        : _vm._e(),
      !_vm.hasRetail && !_vm.hasDining
        ? _c("div", { staticClass: "choose-empty" }, [
            _vm._v(
              "\n      当前账号无可用收银工作台，请联系管理员分配权限\n    "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }